import { createRouter, createWebHistory } from "vue-router";

import store from "@/store";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/pages/Home/App.vue"),
  },
  {
    path: "/home",
    name: "Home2",
    component: () => import("@/pages/Home/App.vue"),
  },
  {
    path: "/templates",
    name: "Templates",
    component: () => import("@/pages/Templates/App.vue"),
  },
  {
    path: "/api/settings",
    name: "ApiSettings",
    component: () => import("@/pages/Api/Settings/View.vue"),
  },
  {
    path: "/dictionaries",
    name: "Dictionaries",
    component: () => import("@/pages/Dictionary/App.vue"),
  },
  {
    path: "/dictionaries/replace/:id",
    name: "Replace dictionary details",
    component: () =>
      import("@/components/ReplaceDictionaries/ReplaceDictionaryDetails.vue"),
  },
  {
    path: "/dictionaries/synonym/:id",
    name: "Synonym dictionary details",
    component: () =>
      import("@/components/SynonymDictionaries/SynonymDictionaryDetails.vue"),
  },
  {
    path: "/dictionaries/language/:id",
    name: "Language dictionary details",
    component: () =>
      import("@/components/LanguageDictionaries/LanguageDictionaryDetails.vue"),
  },
  {
    path: "/edit/:id/v/:version",
    name: "Edit",
    component: () => import("@/pages/Editcopy/App.vue"),
  },
  {
    path: "/translations",
    name: "Translations",
    component: () => import("@/pages/Translations/View.vue"),
  },
  {
    path: "/translations/datasets/:dataset_id/edit",
    name: "Editor",
    component: () => import("@/pages/Translations/Edit.vue"),
  },
  {
    path: "/generative-text",
    name: "GenerativeTextsInspect",
    component: () => import("@/pages/GenerativeTexts/Inspect/View.vue"),
  },
  {
    path: "/generative-text/profiles/:id",
    name: "EditGenerativeTextProfile",
    component: () =>
      import("@/pages/GenerativeTexts/Inspect/ProfileView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const isTemplateRoute =
    to.path === "/templates" ||
    to.path.startsWith("/templates/") ||
    to.path.startsWith("/edit/");

  if (isTemplateRoute && !store.getters.templateModuleEnabled) {
    return "/home";
  }
});

export default router;
